import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  signal,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export enum SocialProofMessage {
  Rating = 'rating',
  Improvement = 'improvement',
  Trusted = 'trusted',
}

@Component({
  selector: 'app-social-proof-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-proof-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'tw-block tw-w-full',
  },
})
export class SocialProofBarComponent implements AfterViewInit {
  protected readonly SocialProofMessage = SocialProofMessage;

  private static readonly MESSAGE_KEYS = [
    SocialProofMessage.Rating,
    SocialProofMessage.Improvement,
    SocialProofMessage.Trusted,
  ] as const;

  private readonly containerRef = viewChild<ElementRef<HTMLElement>>('container');
  private readonly contentRef = viewChild<ElementRef<HTMLElement>>('content');

  readonly messageKey = SocialProofBarComponent.pickMessageKey();
  readonly isOverflowing = signal(false);

  private static pickMessageKey(): SocialProofMessage {
    const index = Math.floor(Math.random() * SocialProofBarComponent.MESSAGE_KEYS.length);
    return SocialProofBarComponent.MESSAGE_KEYS[index];
  }

  ngAfterViewInit(): void {
    document.fonts.ready.then((): void => this.checkOverflow());
  }

  private checkOverflow(): void {
    const container = this.containerRef()?.nativeElement;
    const content = this.contentRef()?.nativeElement;
    if (!container || !content) return;
    this.isOverflowing.set(content.scrollWidth > container.clientWidth);
  }
}
